import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

interface TryOnNudgeTooltipProps {
  visible: boolean;
  onDismiss: () => void;
}

export function TryOnNudgeTooltip({ visible, onDismiss }: TryOnNudgeTooltipProps) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, y: 6, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 4, scale: 0.95 }}
          transition={{ duration: 0.35, ease: 'easeOut', delay: 0.5 }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDismiss();
          }}
          className="absolute top-1 right-10 z-20 flex items-center gap-1.5 px-2.5 py-1.5 rounded-full bg-primary text-primary-foreground text-[11px] font-semibold shadow-lg whitespace-nowrap"
        >
          Try it on!
          <ArrowRight className="w-3 h-3" />
          {/* Arrow pointer pointing right toward the shirt icon */}
          <div className="absolute -right-1 top-1/2 -translate-y-1/2 w-3 h-3 bg-primary rotate-45" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
